module.exports = __webpack_public_path__ + "static/media/kayan.aa7ea478.PNG";